// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import ReactDOM from 'react-dom/client';
import React from 'react';
import './index.scss';
import { APP_ROOT_ID } from './Constants';
import App from './App';

const appRoot = document.getElementById(APP_ROOT_ID) as HTMLElement;

setupDevelopmentTools();
renderApplication();

function renderApplication() {
    if (appRoot) {
        const root = ReactDOM.createRoot(appRoot);
        root.render(
            <React.StrictMode>
                <App />
            </React.StrictMode>
        );

        if (process.env.NODE_ENV === 'development') {
            window.reactAppRoot = root;
        }
    }
}

function setupDevelopmentTools() {
    // Wrap development block with dev mode check - terser gets rid of this block during production build
    if (process.env.NODE_ENV === 'development') {
        if (window.__RD_PROXY__) {
            window.alert('Development mode code should not be included in production build');
        }

        // Initialize development environment
        // https://oppci.eficode.com/site/docs/luna.local-development-environment/latest
        import('@op/luna.local-development-environment/setup').then(({ setup }) =>
            setup({ renderApplication, APP_ROOT_ID })
        );
    }
}
